module.exports = __webpack_public_path__ + "static/media/aeroplano.c77ea2cd.svg";